import { Component } from '@angular/core';

import { VerticalComponent } from './vertical/vertical.component';
import { SaveFeedbackComponent } from '../shared/save-feedback/save-feedback.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone:true,
  imports:[VerticalComponent,SaveFeedbackComponent],
})

export class LayoutComponent {}
